<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Schedule'"
    [canGoBack]="shouldShowAllToDosPage"
    [customBack]="'schedule'"
  />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  @if (isRightSideContent) {
  <tidy-loading-bar class="js-tidy-loading" />
  }
  <tidy-wrapper
    [hasBottomNav]="!shouldShowAllToDosPage"
    (contentHeight)="contentHeight = $event"
    [ngClass]="{'fab-page': loaded && cards?.length > 0 && !hasOnlyReservations && !hasOnlyCrafRequests && !isAllAddressesSelected}"
  >
    <!--Address Filter-->
    @if (!windowService?.isDesktopRes && addressFilterLoaded && addressId &&
    !shouldShowAllToDosPage) {
    <tidy-row [class.tidy-filter-padding]="isAllAddressesSelected">
      <tidy-filter
        [initValue]="addressId"
        [items]="addressFilter"
        [fitContent]="true"
        (optionChange)="changeAddress($event)"
        class="align-center"
      />
    </tidy-row>
    } @if (errorMessage) {
    <tidy-error-message [text]="errorMessage" />
    } @if (isAllAddressesSelected) {
    <tidy-schedule-weekly-filter
      [addresses]="addressResponse"
      [selectedPeriodRange]="selectedPeriodRange"
      (filter)="onFilterChanges($event)"
      (searchChange)="onSearchChanges($event)"
      (goToPreviousPeriod)="goToPreviousPeriod()"
      (goToNextPeriod)="goToNextPeriod()"
      (changeScheduleViewMode)="changeScheduleViewMode($event)"
      (addOwnerBlock)="openAddOwnerBlock()"
    />
    @if ((!isScheduleDataLoaded || !isWeeklyViewReady) && scheduleViewMode !== 'MONTHLY') {
    <!-- Calendar-shaped skeleton on desktop: shows from landing until the
         weekly view reports readiness, so its float-in wave plays once,
         uncut, and the real grid then replaces it in place instantly. -->
    @if (windowService?.isDesktopRes) {
    <div class="remove-wrapper-margin">
      <tidy-schedule-weekly-skeleton />
    </div>
    } @else { @if (!isScheduleDataLoaded) {
    <ion-skeleton-text animated="true" style="width: 100%; height: 100vh" />
    } } } @if (scheduleViewMode === 'MONTHLY') {
    <tidy-schedule-monthly-view
      [properties]="schedule.properties"
      [selectedPeriodRange]="selectedPeriodRange"
      [isLoading]="isLoadingSchedule"
      (clickAction)="handleClickActionMonthlyView($event)"
    />
    } @if (isScheduleDataLoaded) { @if (scheduleViewMode === 'WEEKLY') {
    <div
      class="remove-wrapper-margin"
      [style.display]="!windowService?.isDesktopRes || isWeeklyViewReady ? '' : 'none'"
    >
      <tidy-schedule-weekly-view
        [isMobileResolution]="!windowService?.isDesktopRes"
        [properties]="schedule.properties"
        [daysOfWeek]="daysOfWeek"
        [selectedPeriodRange]="selectedPeriodRange"
        (clickAction)="handleClickAction($event)"
        (assignedPro)="handleAssignedPro($event)"
        (readinessChange)="isWeeklyViewReady = $event"
      />
    </div>
    } } @if (addressResponse?.length == 1 &&
    !addressResponse[0]?.integration?.name && !hasJobsAtOnlyAddress) {
    <div style="padding: 20px; margin-bottom: 100px">
      <tidy-row class="extra-top-padding extra-bottom-padding">
        <tidy-text [title]="'Start Using Your Calendar:'" />
      </tidy-row>
      <tidy-card
        class="vertical-align-center"
        style="padding: 15px 15px 15px 15px"
      >
        <tidy-card-button (action)="bookJobSelectAddress()">
          <tidy-row>
            <ion-row>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/book-job.svg'"
                  style="width: 40px; height: 50px"
                />
              </tidy-row>
              <ion-col>
                <tidy-row>
                  <tidy-text [header]="'Instantly Book'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Book or manage your pros instantly, or find a new one.'"
                  />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
      <tidy-card
        class="vertical-align-center"
        style="padding: 15px 15px 15px 15px"
      >
        <tidy-card-button (action)="goToAllIntegrations()">
          <tidy-row>
            <ion-row>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/integration.svg'"
                  style="width: 40px; height: 50px"
                />
              </tidy-row>
              <ion-col>
                <tidy-row>
                  <tidy-text [header]="'Sync Guest/Tenant Calendar'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Integrate Airbnb or a property management tool to get guest check-ins or tenant move outs synced to your calendar, to make automation easy.'"
                  />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    </div>
    } } @if (!isAllAddressesSelected) { @if (loaded && !hasAddresses) {
    <tidy-row [align]="'center'">
      <tidy-text [body]="'Please add a property to book jobs.'" />
    </tidy-row>
    <tidy-button
      [text]="'Add Property'"
      [action]="goToDashboard.bind(this)"
      class="primary full-width"
    />
    } @if (loaded && hasAddresses) { @if (cardsLoaded) { @if (isRentalClient) {
    @if (automaticBookingEnabled) {
    <tidy-alert>
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/img/search-calendar-enabled.svg'"
          class="title-size"
        />
        <tidy-text [header]="'Auto-Schedule: ON'" />
        <tidy-text
          style="margin-left: 5px"
          [body]="'Edit'"
          (action)="goToIntegrations()"
          class="link"
        />
      </tidy-row>
    </tidy-alert>
    } @if (!automaticBookingEnabled) {
    <tidy-alert>
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/img/search-calendar-disabled.svg'"
          class="title-size"
        />
        <tidy-text [header]="'Auto-Schedule: OFF'" />
        <tidy-text
          style="margin-left: 5px"
          [body]="'Edit'"
          (action)="goToIntegrations()"
          class="link"
        />
      </tidy-row>
    </tidy-alert>
    } } @if (automaticBookingEnabled && !hasCreditCard && waterfallSettings?.key
    !== 'never_use_tidy') {
    <tidy-alert>
      <tidy-row class="extra-bottom-padding vertical-align-center">
        <tidy-image [src]="'assets/img/alert.svg'" class="header-size" />
        <tidy-text [header]="'Payment Info Needed'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'You have auto-schedule enabled but no payment method on file. Please add a payment method to get new Pros from TIDY. '"
        />
        <tidy-text
          [body]="'Add Payment Info'"
          class="link"
          (action)="goToAddCreditCard()"
        />
      </tidy-row>
    </tidy-alert>
    } @if (!hasPhone && (plans?.length > 0 && (cards?.length > 0 ||
    !hasOnlyReservations))) {
    <tidy-alert>
      <tidy-row class="vertical-align-center">
        <tidy-image [src]="'assets/img/alert.svg'" class="body-size" />
        <tidy-text class="red" [actionBody]="'Missing Phone number'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'Please add a phone number so your pro can contact you for your upcoming job.'"
        />
        <tidy-text
          [body]="'Add Phone'"
          (action)="goToEditContactInfo()"
          class="link"
        />
      </tidy-row>
    </tidy-alert>
    } @if (plans?.length === 0 && (cards?.length === 0 || hasOnlyReservations)
    || (plans[0]?.plan_frequency == 'once' && !hasJobs)) {
    <tidy-alert>
      <tidy-row [align]="'center'">
        <tidy-text [body]="'You have no jobs booked at this property.'" />
      </tidy-row>
    </tidy-alert>
    }
    <!--No Jobs Alert-->
    @if ((plans?.length === 0 && cards?.length === 0) ||
    (plans[0]?.plan_frequency == 'once' && cards?.length === 0 )) {
    <tidy-button
      [text]="'Book Job(s)'"
      [action]="bookJob.bind(this, 'add_job')"
      class="primary full-width"
    />
    <tidy-row [align]="'center'" class="extra-top-padding">
      <tidy-text [title]="'Why TIDY?'" />
    </tidy-row>
    @if (showContactConcierge) {
    <tidy-card
      class="vertical-align-center"
      style="padding: 15px 15px 15px 15px"
    >
      <tidy-row>
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/concierge.svg'"
              style="width: 40px; height: 50px"
            />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text [header]="'Concierge Phone Support'" />
            </tidy-row>
            <tidy-row>
              <tidy-text [body]="'We\'re happy to answer any questions! '" />
              <tidy-text
                [body]="'Schedule a Call'"
                (action)="goToScheduleCallPage()"
                class="link"
              />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-row>
    </tidy-card>
    }
    <tidy-card
      class="vertical-align-center"
      style="padding: 15px 15px 15px 15px"
    >
      <tidy-row>
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/peoples.svg'"
              style="width: 40px; height: 50px"
            />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text [header]="'Top Performers'" />
            </tidy-row>
            <tidy-row>
              <tidy-text [body]="'Use certified Pros to only get the best.'" />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-row>
    </tidy-card>
    <tidy-card
      class="vertical-align-center"
      style="padding: 15px 15px 15px 15px"
    >
      <tidy-row>
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/satisfaction-guarantee.svg'"
              style="width: 40px; height: 50px"
            />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text [header]="'Satisfaction Guaranteed'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Protect yourself with our Satisfaction Guarantee.'"
              />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-row>
    </tidy-card>
    <tidy-card
      class="vertical-align-center"
      style="padding: 15px 15px 15px 15px"
    >
      <tidy-row>
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/book-job.svg'"
              style="width: 40px; height: 50px"
            />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text [header]="'Instantly Book'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'View availability instantly & manage the job online.'"
              />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-row>
    </tidy-card>
    <tidy-card
      class="vertical-align-center"
      style="padding: 15px 15px 15px 15px"
    >
      <tidy-row>
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/5-star.svg'"
              style="width: 40px; height: 50px"
            />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text [header]="'Trusted by Thousands'" />
            </tidy-row>
            <tidy-text [body]="'Over 50,000 people have used TIDY. '" />
            <tidy-text
              [body]="'See Reviews'"
              (action)="goToReviews()"
              class="link"
            />
          </ion-col>
        </ion-row>
      </tidy-row>
    </tidy-card>
    <tidy-row [align]="'center'">
      <tidy-text [body]="'*All bookings subject to our '" />
      <tidy-text [body]="'terms'" (action)="goToTerms()" class="link" />
    </tidy-row>
    } @if (hasRequests) {
    <tidy-row>
      <tidy-text [header]="'Requests'" />
    </tidy-row>
    } @for (card of cards; track card) {
    <!--CRAF Template-->
    @if (card?.template === 'pending_availability_request') {
    <tidy-card>
      <!--CRAF Template / Pending request_type-->
      @if (card?.template_data?.request_type === 'pending') {
      <tidy-row class="extra-bottom-padding vertical-align-center">
        <tidy-image
          [src]="'assets/icon/searching.svg'"
          class="header-size wiggle-animation"
        />
        <tidy-text [header]="'Request Pending'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text [body]="card.proRequestBody" />
      </tidy-row>
      @for (day of card.requestTimeList; track day) {
      <tidy-row class="extra-bottom-padding">
        <tidy-text [body]="day" />
      </tidy-row>
      } @if (card?.template_data?.job?.is_private) {
      <tidy-row class="extra-bottom-padding">
        <tidy-button
          [text]="'Assign Pro'"
          [action]="goToChangePro.bind(this, card)"
          class="primary"
        />
      </tidy-row>
      }
      <!--<tidy-row class="extra-bottom-padding">
                  <tidy-button
                    [text]="'Change Request'"
                    [action]="editProRequest.bind(this, card?.template_data?.availability_request, card?.template_data?.homekeeper, card?.template_data?.availability_request?.request_times)"
                    class="secondary">
                  </tidy-button>
                </tidy-row>-->
      <tidy-row [align]="'center'" class="extra-top-padding">
        <tidy-text
          (action)="cancelProRequest(card?.template_data?.availability_request)"
          [body]="'Cancel Request'"
          class="link"
        />
      </tidy-row>
      @if (card?.bookingFormAnswers?.length > 0) {
      <tidy-row class="extra-top-padding extra-bottom-padding">
        <tidy-divider />
      </tidy-row>
      <tidy-row class="vertical-align-center extra-bottom-padding">
        <tidy-image [src]="'assets/img/information.svg'" class="header-size" />
        <tidy-text [header]="'Job Note'" />
      </tidy-row>
      @for (answer of card?.bookingFormAnswers; track answer) { @if
      (answer?.template_input?.type == 'text' || answer?.template_input?.type ==
      'text_area') {
      <tidy-row>
        <tidy-text
          [body]="answer?.template_input?.label + ': ' + answer?.data?.value"
        />
      </tidy-row>
      @if (answer?.template_input?.image_url) {
      <tidy-photo-note [src]="answer?.template_input?.image_url" />
      } } @if (answer?.template_input?.type == 'select') {
      <tidy-row>
        <tidy-text
          [body]="answer?.template_input?.label + ': ' + answer.bookingFormSelectValue"
        />
      </tidy-row>
      @if (answer?.template_input?.image_url) {
      <tidy-photo-note [src]="answer?.template_input?.image_url" />
      } } @if (answer?.template_input?.type == 'multiselect') {
      <tidy-row>
        <tidy-text
          [body]="answer?.template_input?.label + ': ' + answer.bookingFormMultiselectValue"
        />
      </tidy-row>
      @if (answer?.template_input?.image_url) {
      <tidy-photo-note [src]="answer?.template_input?.image_url" />
      } } @if (answer?.template_input?.type == 'file' &&
      answer?.template_input?.data?.type == 'image') {
      <tidy-row>
        <tidy-text [body]="answer?.template_input?.label" />
      </tidy-row>
      <tidy-carrousel
        class="photo-notes-carrousel only-padding-bottom"
        [scaleImages]="true"
      >
        <tidy-photo-note *tidyCarrousel [src]="answer?.data?.value" />
      </tidy-carrousel>
      } @if (answer?.template_input?.type == 'files' &&
      answer?.template_input?.data?.type == 'images') {
      <tidy-row>
        <tidy-text [body]="answer?.template_input?.label" />
      </tidy-row>
      <tidy-carrousel
        class="photo-notes-carrousel only-padding-bottom"
        [scaleImages]="true"
      >
        @for (imageUrl of answer?.data?.value; track imageUrl) {
        <tidy-photo-note *tidyCarrousel [src]="imageUrl" />
        }
      </tidy-carrousel>
      } } } }
      <!--CRAF Template / Countered request_type-->
      @if (card?.template_data?.request_type === 'countered') {
      <tidy-row class="extra-bottom-padding vertical-align-center">
        <tidy-image
          [src]="'assets/img/request-counter.svg'"
          class="title-size"
        />
        <tidy-text
          [header]="card?.template_data?.homekeeper?.homekeeper_name"
          [translate]="false"
        /><span>&nbsp;</span>
        <tidy-text [header]="'Proposed Other Times'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="card?.template_data?.homekeeper?.homekeeper_name"
          [translate]="false"
        />
        <tidy-text
          [body]="' indicated that they were not available for the times you requested, but provided other times they are available.'"
        />
      </tidy-row>
      <tidy-button
        [text]="'View Other Times'"
        [action]="goToRequestProCounter.bind(this, card?.template_data?.availability_request, card?.template_data?.homekeeper)"
        class="primary"
      />
      }
    </tidy-card>
    } } @if (showContactConcierge && (plans?.length !== 0 || cards?.length !==
    0)) {
    <tidy-row [align]="'center'">
      <tidy-text [body]="'Need Help? '" /><br />
      <tidy-text
        [actionBody]="'Schedule a Call'"
        (action)="goToScheduleCallPage()"
        class="link"
      />
    </tidy-row>
    }
    <!--Plans-->
    @if (plans?.length > 0) {
    <tidy-row>
      <tidy-text [header]="'Plans'" />
    </tidy-row>
    @if (plans[0]?.plan_frequency !== 'once') {
    <tidy-card>
      <tidy-card-button (action)="goToPlansPage()" [hideArrow]="true">
        <tidy-row>
          <tidy-grid>
            <ion-row>
              <ion-col size="2">
                <div style="margin: auto">
                  <tidy-image
                    [src]="'assets/img/icons/blue_sparkle.svg'"
                    style="width: 35px"
                  />
                </div>
              </ion-col>
              <ion-col size="10">
                <tidy-text
                  [body]="plans[0]?.formatted_plan_with_weekdays_and_times | titlecase"
                />
                @if (plans?.length > 1) {
                <tidy-text [body]="' + ' + plans?.length - 1" /><span
                  >&nbsp;</span
                >
                <tidy-text [body]="'More'" />
                }<br />
                <tidy-text
                  class="link"
                  [actionBody]="(plans?.length > 1) ? 'Edit Plans' : 'Edit Plan'"
                />
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-row>
      </tidy-card-button>
    </tidy-card>
    } @if (plans[0]?.plan_frequency == 'once' || hasAllOneTimePlans) {
    <tidy-row>
      @if (plans[0]?.plan_frequency == 'once') {
      <tidy-text [body]="'One Time Plan '" />
      } @if (plans[0]?.plan_frequency !== 'once') {
      <tidy-text [body]="'No Recurring Plans '" />
      }
      <tidy-text
        (action)="goToPlansPage()"
        [actionBody]="'Edit'"
        class="link"
      />
    </tidy-row>
    } @if (!hasAllOneTimePlans && !hasJobs) {
    <tidy-alert>
      <tidy-text
        [body]="'You still have a plan scheduled. We’ll continue to book jobs automatically per your plan. If you want to edit your plan click <b>“Edit Plan”</b> above.'"
      />
    </tidy-alert>
    } } @if (hasOnlyReservations) {
    <tidy-button
      [text]="'Book Job(s)'"
      [action]="bookJob.bind(this, 'add_job')"
      class="primary full-width"
    />
    <tidy-row>
      <tidy-text [header]="'Reservations'" />
    </tidy-row>
    } @if (cards?.length > 0) { @if (!hasOnlyReservations) {
    <tidy-row>
      <tidy-text [header]="'Jobs'" />
    </tidy-row>
    } @if (hasOnlyCrafRequests) {
    <tidy-alert>
      <tidy-row>
        <tidy-text [body]="'No jobs booked.'" />
      </tidy-row>
    </tidy-alert>
    } @if (hasOnlyCrafRequests) {
    <tidy-button
      [text]="'Book Job(s)'"
      [action]="bookJob.bind(this, 'add_job')"
      class="primary full-width"
    />
    }
    <!--Alert that appears if you have multiple job request pending-->
    @if (twoCoops && !(hasReservations || automaticBookingEnabled)) {
    <tidy-alert>
      <tidy-row class="vertical-align-center">
        <tidy-image [src]="'assets/img/alert.svg'" class="body-size" />
        <tidy-text
          [body]="'You initiated multiple job requests.  If you do not want multiple jobs please cancel one request.'"
        />
      </tidy-row>
    </tidy-alert>
    } @for (card of cards; track card; let index = $index) {
    <!--Address Alert Template / address_alerts-multiple_cleanings_on_same_day_alert ID-->
    @if (card?.template == 'address_alerts' && card?.id ==
    'address_alerts-multiple_cleanings_on_same_day_alert') {
    <tidy-alert>
      <tidy-row>
        <tidy-image [src]="'assets/img/alert.svg'" class="body-size" />
        <tidy-text [body]="'You have multiple jobs scheduled for'" /><span
          >&nbsp;</span
        >
        @for (date of card?.template_data?.alert_data?.dates; track date; let
        last = $last) {
        <span>
          <tidy-text
            [body]="(date | parseDateTime: 'MMM d') + (last ? '.' : ',')"
          /><span>&nbsp;</span>
          @if (last) {
          <tidy-text
            [body]="'If you do not want multiple jobs on that day please cancel one.'"
          />
          }
        </span>
        }
      </tidy-row>
    </tidy-alert>
    }
    <!--Alert that appears when automatic booking is on-->
    @if (card?.fourWeekAlert) {
    <tidy-alert>
      <tidy-row>
        <tidy-text
          [body]="('TIDY will automatically send a job request to your list of Pros once a reservation is within ' | translate) + numberOfDaysToBookWithin + (' days of the check in date.' | translate)"
        />
        <tidy-text
          [body]="'Learn More'"
          class="link"
          (action)="learnMoreReservations()"
        />
      </tidy-row>
    </tidy-alert>
    }
    <!--Job Request Template / Pending Status-->
    @if (card.template == 'job_request' && card.template_data.job_request_status
    == 'pending') {
    <tidy-card>
      <tidy-card-button (action)="goToJobPage(card)" class="arrow-to-top">
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/icon/searching.svg'"
            class="header-size wiggle-animation"
          />
          <tidy-text
            [header]="card?.template_data?.job?.service_type_details?.name | titlecase"
          />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="'Searching for a pro that matches your preferences. When scheduled, we will message you.'"
          />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/play-circle-outline.svg'"
            class="body-size"
          />
          <tidy-text [body]="'Earliest Start:'" /><span>&nbsp;</span>
          <tidy-text
            [body]="(card?.template_data?.booking?.start_date_no_earlier_than | parseDateTime:'ddd MMM d') + ' ' + (card?.template_data?.booking?.start_time_no_earlier_than | parseDateTime:'h:mma')"
          />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/stop-circle-outline.svg'"
            class="body-size"
          />
          <tidy-text [body]="'Latest Finish:'" /><span>&nbsp;</span>
          <tidy-text
            [body]="(card?.template_data?.booking?.end_date_no_later_than | parseDateTime:'ddd MMM d') + ' ' + (card?.template_data?.booking?.end_time_no_later_than | parseDateTime:'h:mma')"
          />
        </tidy-row>
        @if (card.hasQuotes &&
        !card?.template_data?.job?.service_type_details?.name?.includes('2
        Pros')) {
        <tidy-row class="extra-top-padding">
          <tidy-alert class="light-green-background">
            <tidy-row class="vertical-align-center">
              <tidy-text
                [body]="'There are some bids available for this job.'"
              /><span>&nbsp;</span>
              <!-- Show history instead of View Bids when there's an accepted pro -->
              @if (shouldShowHistoryInsteadOfBids(card)) {
              <tidy-text [body]="'History:'" />
              @for (pro of getNonAcceptedPros(card); track trackByProId($index,
              pro)) {
              <div style="margin-left: 10px">
                <tidy-text
                  [body]="pro.first_name + ' ' + pro.last_name + ' - ' + (pro.amount | tcurrency)"
                />
              </div>
              } }

              <!-- Show View Bids button when no pro is accepted -->
              @if (!shouldShowHistoryInsteadOfBids(card)) {
              <tidy-text
                [actionBody]="'View Bids'"
                class="link"
                (action)="goToBidsPage(card, card?.template_data?.booking)"
              />
              }
            </tidy-row>
          </tidy-alert>
        </tidy-row>
        }
      </tidy-card-button>
    </tidy-card>
    }
    <!--Job Request Template / Failed Status-->
    @if (card.template == 'job_request' && card.template_data.job_request_status
    == 'failed') {
    <tidy-card>
      <tidy-card-button (action)="goToJobPage(card)" class="arrow-to-top">
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/img/alert.svg'" class="header-size" />
          <tidy-text
            [header]="card?.template_data?.job?.service_type_details?.name | titlecase"
          />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text [body]="'No pro accepted your request.'" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/play-circle-outline.svg'"
            class="body-size"
          />
          <tidy-text [body]="'Earliest Start:'" /><span>&nbsp;</span>
          <tidy-text
            [body]="(card?.template_data?.booking?.start_date_no_earlier_than | parseDateTime:'ddd MMM d') + ' ' + (card?.template_data?.booking?.start_time_no_earlier_than | parseDateTime:'h:mma')"
          />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/stop-circle-outline.svg'"
            class="body-size"
          />
          <tidy-text [body]="'Latest Finish:'" /><span>&nbsp;</span>
          <tidy-text
            [body]="(card?.template_data?.booking?.end_date_no_later_than | parseDateTime:'ddd MMM d') + ' ' + (card?.template_data?.booking?.end_time_no_later_than | parseDateTime:'h:mma')"
          />
        </tidy-row>
        @if (card.hasQuotes &&
        !card?.template_data?.job?.service_type_details?.name?.includes('2
        Pros')) {
        <tidy-row class="extra-top-padding">
          <tidy-alert class="light-green-background">
            <tidy-row class="vertical-align-center">
              <tidy-text
                [body]="'There are some bids available for this job.'"
              /><span>&nbsp;</span>
              <!-- Show history instead of View Bids when there's an accepted pro -->
              @if (shouldShowHistoryInsteadOfBids(card)) {
              <tidy-text [body]="'History:'" />
              @for (pro of getNonAcceptedPros(card); track trackByProId($index,
              pro)) {
              <div style="margin-left: 10px">
                <tidy-text
                  [body]="pro.first_name + ' ' + pro.last_name + ' - ' + (pro.amount | tcurrency)"
                />
              </div>
              } }

              <!-- Show View Bids button when no pro is accepted -->
              @if (!shouldShowHistoryInsteadOfBids(card)) {
              <tidy-text
                [actionBody]="'View Bids'"
                class="link"
                (action)="goToBidsPage(card, card?.template_data?.booking)"
              />
              }
            </tidy-row>
          </tidy-alert>
        </tidy-row>
        }
      </tidy-card-button>
    </tidy-card>
    }
    <!--Reservation Template-->
    @if (card?.template === 'guest_reservations') {
    <tidy-alert style="padding: 0 15px">
      <tidy-card-button
        class="no-below-stroke"
        (action)="goToReservation(card)"
      >
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/img/calendar-link.svg'"
            class="header-size"
          />
          <tidy-text
            [header]="(card?.template_data?.check_in_date | parseDateTime:'MMM d') + ' - ' + (card?.template_data?.check_out_date | parseDateTime:'MMM d')"
          /><span>&nbsp;</span>
          <tidy-text [header]="'Reservation'" />
        </tidy-row>
        @if (card?.template_data?.status === 'inactivated_after_check_in') {
        <tidy-row class="vertical-align-center">
          <tidy-text [body]="'(Cancelled after Check-In)'" />
        </tidy-row>
        }
      </tidy-card-button>
    </tidy-alert>
    }
    <!--Feedback Template-->
    @if (card?.template === 'feedback') {
    <tidy-card>
      <tidy-row class="extra-bottom-padding">
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="card?.template_data?.job?.service_type_details?.service_category?.icon_url"
              style="width: 30px"
            />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text
                [header]="card?.template_data?.job?.service_type_details?.name | titlecase"
              />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="(card?.template_data?.job?.start_datetime_local | parseDateTime: 'ddd') + ' ' + (card?.template_data?.job?.start_datetime_local | parseDateTime: 'MMM d')"
              /><span>&nbsp;</span> <tidy-text [body]="'at'" /><span
                >&nbsp;</span
              >
              <tidy-text
                [body]="card?.template_data?.job?.start_datetime_local | parseDateTime: 'h:mma'"
              />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-row>
      @for (pro of card?.template_data?.homekeepers; track pro; let first =
      $first) {
      <ng-container class="extra-bottom-padding">
        <tidy-row class="extra-bottom-padding" [align]="'center'">
          <tidy-text [title]="'Rate'" /><span>&nbsp;</span>
          <tidy-text [title]="pro?.first_name" [translate]="false" />
          <tidy-text [title]="'\'s Job'" />
        </tidy-row>
        <tidy-row>
          <tidy-grid>
            <ion-row>
              <ion-col size="2" />
              <ion-col size="4">
                <tidy-round-button
                  class="black"
                  [image]="'assets/img/icons/thumb-down.svg'"
                  (action)="needsWork(card, pro)"
                  [label]="'Needs Work'"
                />
              </ion-col>
              <ion-col size="4">
                <tidy-round-button
                  class="green"
                  [image]="'assets/img/icons/white-heart.svg'"
                  (action)="loveIt(card, pro)"
                  [label]="'Love It'"
                />
              </ion-col>
              <ion-col size="2" />
            </ion-row>
          </tidy-grid>
        </tidy-row>
        <tidy-row
          class="extra-top-padding"
          [align]="'center'"
          [ngClass]="card?.template_data?.homekeepers?.length > 1 && first ? 'extra-bottom-padding' : ''"
        >
          <tidy-text [body]="'Any negative feedback is anonymized. If'" /><span
            >&nbsp;</span
          >
          <tidy-text [body]="pro?.first_name" [translate]="false" /><span
            >&nbsp;</span
          >
          <tidy-text [body]="'did not arrive please'" /><span>&nbsp;</span>
          <tidy-text
            (action)="reportNoShow(pro?.first_name, card?.template_data?.job?.id, pro?.id)"
            [body]="'click here'"
            class="link"
          />
        </tidy-row>
      </ng-container>
      }
    </tidy-card>
    }
    <!--Cleaning Template-->
    @if (card?.template == 'cleaning') {
    <tidy-card>
      <!--Service & Date/Time Header-->
      @for (potentialHomekeeper of card?.template_data?.potential_homekeepers;
      track potentialHomekeeper) { @if (potentialHomekeeper?.status ==
      'declined_by_homekeeper' || potentialHomekeeper?.status ==
      'accepted_by_customer') {
      <tidy-row>
        <tidy-alert
          [class.light-green-background]="card.hasQuotes && potentialHomekeeper?.status == 'declined_by_homekeeper'"
          [class.yellow-background]="potentialHomekeeper?.status == 'accepted_by_customer' || (!card.hasQuotes && potentialHomekeeper?.status == 'declined_by_homekeeper')"
        >
          <tidy-row>
            <tidy-image
              [src]="'assets/svg/alert-circle-outline.svg'"
              class="body-size"
            />
            @if (potentialHomekeeper?.status == 'accepted_by_customer') {
            <tidy-text [body]="'You accepted a quote from '" />
            <tidy-text
              [body]="potentialHomekeeper?.first_name + ' ' + potentialHomekeeper?.last_name || 'Pro'"
            />
            <tidy-text [body]="'. We are confirming with him.'" />
            } @if (potentialHomekeeper?.status == 'declined_by_homekeeper') {
            <tidy-text
              [body]="potentialHomekeeper?.first_name + ' ' + potentialHomekeeper?.last_name + ' '"
            />
            <tidy-text [body]="'declined the job. '" />
            @if (card.hasQuotes) {
            <tidy-text [body]="'There are some bids available for this job.'" />
            } }
          </tidy-row>
          @if (card.hasQuotes && potentialHomekeeper?.status ==
          'declined_by_homekeeper') {
          <tidy-row>
            <!-- Show history instead of View Bids when there's an accepted pro -->
            @if (shouldShowHistoryInsteadOfBids(card)) {
            <tidy-text [body]="'History:'" />
            @for (pro of getNonAcceptedPros(card); track trackByProId($index,
            pro)) {
            <div style="margin-left: 10px">
              <tidy-text
                [body]="pro.first_name + ' ' + pro.last_name + ' - ' + (pro.amount | tcurrency)"
              />
            </div>
            } }

            <!-- Show View Bids button when no pro is accepted -->
            @if (!shouldShowHistoryInsteadOfBids(card)) {
            <tidy-text
              [actionBody]="'View Bids'"
              class="link"
              (action)="goToBidsPage(card, card?.template_data?.booking)"
            />
            }
          </tidy-row>
          }
        </tidy-alert>
      </tidy-row>
      } }
      <tidy-card-button
        (action)="goToJobPage(card)"
        class="no-below-stroke no-padding"
        [style.padding-top]="card?.template_data?.potential_homekeepers?.length > 0 ? '5px' : '0'"
      >
        <tidy-row class="no-padding">
          <ion-row>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="card?.template_data?.job?.service_type_details?.service_category?.icon_url"
                style="width: 30px"
              />
            </tidy-row>
            <ion-col>
              <tidy-row>
                <tidy-text
                  [header]="(card?.template_data?.job?.service_type_details?.name || card?.template_data?.booking?.bookable_service?.name) | titlecase"
                />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="(card?.template_data?.job?.start_datetime_local | parseDateTime: 'ddd') + ' ' + (card?.template_data?.job?.start_datetime_local | parseDateTime: 'MMM d')"
                /><span>&nbsp;</span> <tidy-text [body]="'at'" /><span
                  >&nbsp;</span
                >
                <tidy-text
                  [body]="card?.template_data?.job?.start_datetime_local | parseDateTime: 'h:mma'"
                />
              </tidy-row>
            </ion-col>
          </ion-row>
        </tidy-row>
      </tidy-card-button>
      <!--Cant Access Scenario-->
      @if (card?.template_data?.scenario_name === 'hk_initiated_no_access') {
      <tidy-row class="extra-top-padding vertical-align-center">
        <tidy-image [src]="'assets/img/alert.svg'" class="title-size" />
        <tidy-text
          [title]="card?.template_data?.homekeepers[0]?.first_name"
          [translate]="false"
        /><span>&nbsp;</span>
        <tidy-text [title]="'Needs Help'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="card?.template_data?.homekeepers[0]?.first_name"
          [translate]="false"
        /><span>&nbsp;</span>
        <tidy-text
          [body]="'is having trouble accessing your property.  Please reach out to help.'"
        />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-button
          [text]="('Contact ' | translate) + card?.template_data?.homekeepers[0]?.first_name"
          [action]="contactPro.bind(this, card)"
          class="primary"
        />
      </tidy-row>
      }
      <!--Cant Access Confirmed Scenario-->
      @if (card?.template_data?.scenario_name === 'hk_confirmed_no_access') {
      <tidy-row class="extra-bottom-padding">
        <tidy-divider />
      </tidy-row>
      <tidy-row class="extra-bottom-padding vertical-align-center">
        <tidy-image [src]="'assets/img/alert.svg'" class="title-size" />
        <tidy-text [title]="'Action Needed'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="card?.template_data?.homekeepers[0]?.first_name"
          [translate]="false"
        /><span>&nbsp;</span>
        <tidy-text [body]="'confirmed they could not access your property.'" />
      </tidy-row>
      <tidy-row>
        <tidy-button
          [text]="'Reschedule Job'"
          [action]="rescheduleJob.bind(this, card)"
          class="primary"
        />
      </tidy-row>
      <tidy-row>
        <tidy-button
          [text]="'Skip Job'"
          [action]="skipJob.bind(this, card?.template_data?.booking?.id, card?.template_data?.job?.id)"
          class="secondary"
        />
      </tidy-row>
      <tidy-row class="extra-top-padding" [align]="'center'">
        <tidy-text [body]="'If you believe'" /><span>&nbsp;</span>
        <tidy-text
          [body]="card?.template_data?.homekeepers[0]?.first_name"
          [translate]="false"
        /><span>&nbsp;</span>
        <tidy-text [body]="'was the one who cancelled, please'" /><span
          >&nbsp;</span
        >
        <tidy-text
          (action)="reportNoShow(card?.template_data?.homekeepers[0]?.first_name, card?.template_data?.job?.id, card?.template_data?.homekeepers[0]?.id)"
          [body]="'click here'"
          class="link"
        />
      </tidy-row>
      }
      <!--Client Refused Service Scenario-->
      @if (card?.template_data?.scenario_name ===
      'hk_reported_client_cancellation') {
      <tidy-row class="extra-top-padding vertical-align-center">
        <tidy-image [src]="'assets/img/alert.svg'" class="title-size" />
        <tidy-text [title]="'Action Needed'" />
      </tidy-row>
      @if (card?.template_data?.homekeepers?.[0]?.first_name) {
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="card?.template_data?.homekeepers[0]?.first_name"
          [translate]="false"
        /><span>&nbsp;</span>
        <tidy-text [body]="'reported that you cancelled the job.'" />
      </tidy-row>
      } @else {
      <tidy-row class="extra-bottom-padding">
        <tidy-text [body]="'Your Pro reported that you cancelled the job.'" />
      </tidy-row>
      }
      <tidy-row>
        <tidy-button
          [text]="'Book New Time'"
          [action]="rescheduleJob.bind(this, card)"
          class="primary"
        />
      </tidy-row>
      @if (card?.template_data?.homekeepers?.[0]?.first_name &&
      card?.template_data?.homekeepers?.[0]?.id) {
      <tidy-row class="extra-top-padding" [align]="'center'">
        <tidy-text [body]="'If you believe'" /><span>&nbsp;</span>
        <tidy-text
          [body]="card?.template_data?.homekeepers[0]?.first_name"
          [translate]="false"
        /><span>&nbsp;</span>
        <tidy-text [body]="'was the one who cancelled, please'" /><span
          >&nbsp;</span
        >
        <tidy-text
          (action)="reportNoShow(card?.template_data?.homekeepers[0]?.first_name, card?.template_data?.job?.id, card?.template_data?.homekeepers[0]?.id)"
          [body]="'click here'"
          class="link"
        />
      </tidy-row>
      }
      }
      <!--Marked No Show Scenario-->
      @if (card?.template_data?.scenario_name ===
      'customer_reported_hk_no_showed' || card?.template_data?.scenario_name ===
      'concierge_reported_hk_no_showed') {
      <tidy-row class="extra-bottom-padding">
        <tidy-divider />
      </tidy-row>
      <tidy-row class="extra-bottom-padding vertical-align-center">
        <tidy-image [src]="'assets/img/alert.svg'" class="title-size" />
        <tidy-text [title]="'Action Needed'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text [body]="'You reported that'" /><span>&nbsp;</span>
        <tidy-text
          [body]="card?.template_data?.homekeepers[0]?.first_name"
          [translate]="false"
        /><span>&nbsp;</span>
        <tidy-text [body]="'did not show up to the job.'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="'We\'re so sorry that they did that!  We are reaching out to find out what happened.'"
        />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="'Of course you will not be billed for this, which means any credit will remain in your account.'"
        />
      </tidy-row>
      @if (card?.template_data?.booking?.cancelled_at) {
      <tidy-row>
        <tidy-button
          [text]="'Book New Time'"
          [action]="rescheduleJob.bind(this, card)"
          class="primary"
        />
      </tidy-row>
      } @else {
      <tidy-row>
        <tidy-button
          [text]="'Request Substitute'"
          [action]="requestSubstitute.bind(this, card?.template_data?.job?.id)"
          class="primary"
        />
      </tidy-row>
      <tidy-row>
        <tidy-button
          [text]="'Reschedule Job'"
          [action]="rescheduleJob.bind(this, card)"
          class="secondary"
        />
      </tidy-row>
      <tidy-row>
        <tidy-button
          [text]="'Assign a Pro'"
          [action]="goToChangePro.bind(this, card)"
          class="secondary"
        />
      </tidy-row>
      <tidy-row [align]="'center'">
        <tidy-text
          (action)="skipJob(card?.template_data?.booking?.id, card?.template_data?.job?.id)"
          [body]="'Skip Job'"
          class="link"
        />
      </tidy-row>
      }
      }
      <!--Updates Section-->
      @if (showUpdates(card)) {
      <message
        [message]="card?.template_data?.activity_timelines[0]?.activity_timeline_items[0]"
        [showJobLink]="false"
        [addExtraPadding]="false"
      />
      @if
      (card?.template_data?.activity_timelines[0]?.activity_timeline_items?.length
      > 1) {
      <tidy-text
        [helper]="'+ ' + card?.template_data?.activity_timelines[0]?.activity_timeline_items?.length - 1"
      /><span>&nbsp;</span>
      <tidy-text [helper]="'more updates'" />
      } }
      <!--Unassigned Scenario-->
      @if (card?.template_data?.unassigned) {
      <tidy-row class="extra-bottom-padding">
        <tidy-divider />
      </tidy-row>
      @if (card?.template_data?.scenario_type === 'unassigned') {
      <tidy-row class="vertical-align-center extra-bottom-padding">
        @if (card?.template_data?.unassigned?.call_to_action === 'Other Actions
        (No Action Needed)') {
        <tidy-image
          [src]="'assets/icon/searching.svg'"
          class="title-size wiggle-animation"
        />
        <tidy-text [title]="'Searching for Substitute'" />
        } @else {
        <tidy-image [src]="'assets/img/alert.svg'" class="title-size" />
        <tidy-text [title]="'Action Needed'" />
        }
      </tidy-row>
      } @if (card?.template_data?.scenario_type === 'manual_request') {
      <tidy-row class="vertical-align-center extra-bottom-padding">
        <tidy-image
          [src]="'assets/icon/searching.svg'"
          class="title-size wiggle-animation"
        />
        <tidy-text
          [title]="card?.template_data?.scenario_name === 'same_day_cleaning_substitute_requested' ? 'Searching for Pro' : 'Searching for Substitute'"
        />
      </tidy-row>
      } @if (card?.template_data?.unassigned?.homekeeper) {
      <tidy-row class="extra-bottom-padding">
        <tidy-text [header]="'Message from'" /><span>&nbsp;</span>
        <tidy-text
          [header]="card?.template_data?.unassigned?.homekeeper?.first_name + ':'"
          [translate]="false"
        /><br />
        @for (text of card?.template_data?.unassigned?.homekeeper?.text; track
        text) { @if (text?.type === 'string') {
        <tidy-text [body]="text?.value" />
        } @if (text?.type === 'br') {
        <br />
        } }
      </tidy-row>
      }
      <tidy-row class="extra-bottom-padding">
        @if (card?.template_data?.unassigned?.homekeeper !== undefined) {
        <tidy-text [header]="'Message from Concierge:'" /><br />
        } @for (text of card?.template_data?.unassigned?.concierge?.text; track
        text) { @if (text?.type === 'string') {
        <tidy-text [body]="text?.value" />
        } @if (text?.type === 'list') { @for (item of text?.value; track item) {
        @if (item?.type === 'string') {
        <tidy-text [body]="item?.value" />
        } @if (item?.type === 'br') {
        <br />
        } } } @if (text?.type === 'br') {
        <br />
        } }
      </tidy-row>
      <tidy-row
        class="extra-bottom-padding"
        [alignLastItemRight]="card?.template_data?.scenario_type === 'manual_request'"
      >
        <tidy-text [header]="card.callToActionText" />
        @if (card?.template_data?.scenario_type === 'manual_request') {
        <tidy-text
          (action)="learnMoreSdc()"
          [body]="'Learn More'"
          class="link"
        />
        }
      </tidy-row>
      @for (button of card?.template_data?.unassigned?.buttons; track button) {
      <tidy-row>
        <tidy-button
          [text]="button?.text"
          [action]="unassignedAction.bind(this, button?.action, card)"
          [ngClass]="button?.color === 'green' ? 'primary' : 'secondary'"
        />
      </tidy-row>
      }
      <tidy-row>
        <tidy-button
          [text]="'Assign a Pro'"
          [action]="goToChangePro.bind(this, card)"
          class="secondary"
        />
      </tidy-row>
      }
    </tidy-card>
    } } } } } } @if (!loaded && !isAllAddressesSelected) {
    <tidy-row class="extra-bottom-padding">
      <ion-skeleton-text animated style="width: 20%; height: 16px" />
    </tidy-row>
    <tidy-card>
      <tidy-card-button [hideArrow]="true">
        <tidy-row>
          <tidy-grid>
            <ion-row>
              <ion-col size="2">
                <ion-skeleton-text animated style="width: 50%; height: 20px" />
              </ion-col>
              <ion-col size="10">
                <ion-skeleton-text animated style="width: 100%" />
                <ion-skeleton-text animated style="width: 100%" />
                <ion-skeleton-text animated style="width: 22%" />
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-row>
      </tidy-card-button>
    </tidy-card>
    <tidy-row>
      <ion-item style="--min-height: 0">
        <ion-skeleton-text
          animated
          slot="start"
          style="width: 14%; height: 16px"
        />
        <ion-skeleton-text
          animated
          slot="end"
          style="width: 50%; height: 16px"
        />
      </ion-item>
    </tidy-row>
    @for (item of [1, 2, 3, 4, 5, 6, 7, 8]; track item) {
    <tidy-card>
      <tidy-card-button [hideArrow]="true" class="no-below-stroke no-padding">
        <tidy-row class="no-padding">
          <ion-row>
            <tidy-row class="vertical-align-center">
              <ion-skeleton-text
                animated
                slot="start"
                style="width: 32px; height: 32px"
              />
            </tidy-row>
            <ion-col>
              <tidy-row>
                <tidy-row class="vertical-align-center">
                  <ion-skeleton-text
                    animated
                    slot="start"
                    style="width: 140px"
                  />
                </tidy-row>
              </tidy-row>
              <tidy-row>
                <tidy-row class="vertical-align-center">
                  <ion-skeleton-text
                    animated
                    slot="start"
                    style="width: 155px"
                  />
                </tidy-row>
              </tidy-row>
            </ion-col>
          </ion-row>
        </tidy-row>
      </tidy-card-button>
    </tidy-card>
    } }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
<app-scroll-wrapper [templateContent]="content" />
} @if (isRightSideContent) {
<ng-container *ngTemplateOutlet="content" />
} @if (isRightSideContent && loaded && ((cards?.length > 0 &&
!hasOnlyReservations && !hasOnlyCrafRequests && !isAllAddressesSelected) ||
(isAllAddressesSelected && !windowService?.isDesktopRes))) {
<tidy-fab [isRightSidePanelButton]="true" [disableToggle]="true">
  <tidy-fab-button class="main-btn" (click)="onFABButtonClick()">
    <tidy-image src="assets/svg/add-heavy.svg" class="large-body-size" />
    <tidy-text largeBody="Add Job" class="white" />
  </tidy-fab-button>
</tidy-fab>
} @if (!isRightSideContent && loaded && ((cards?.length > 0 &&
!hasOnlyReservations && !hasOnlyCrafRequests && !isAllAddressesSelected) ||
(isAllAddressesSelected && !windowService?.isDesktopRes))) {
<tidy-fab
  [isRightSidePanelButton]="false"
  [top]="contentHeight"
  [disableToggle]="true"
  [class.bottom-nav-padding]="!shouldShowAllToDosPage"
>
  <tidy-fab-button class="main-btn" (click)="onFABButtonClick()">
    <tidy-image src="assets/svg/add-heavy.svg" class="large-body-size" />
    <tidy-text largeBody="Add Job" class="white" />
  </tidy-fab-button>
</tidy-fab>
} @if (!shouldShowAllToDosPage) {
<tidy-bottom-nav activeRoute="/schedule" />
}
